<template>
  <div class="feeDetail">
    <div class="warp">
        <div class="feeCard">
            <h5>
                {{$t('miningfee.title')}}
            </h5>
            <div class="blance">
              <b>
                {{$t('miningfee.balance')}}
              </b>
              <span>
                {{fixDFun(msg.balance,'usdt')}}
              </span>
              <label for="">{{feeCoin}}</label>
            </div>
            <div class="user-content">
                <!-- <div class="user-item">
                    <p class="user-title">
                        账户名称
                        {{$t('miningfee.name')}}
                    </p>
                    <div class="user-value">
                      VDex 手续费存储专用账户
                      {{$t('miningfee.vdexAccount')}}
                    </div>
                </div>
                <div class="user-item">
                    <p class="user-title">
                        存储账户UID
                        {{$t('miningfee.uid')}}
                    </p>
                    <div class="user-value">
                        {{msg.uid}}
                    </div>
                </div> -->
                <div class="user-item">
                    <p class="user-title">
                        <!-- 链上地址 -->
                        {{$t('miningfee.ethAddress')}}
                    </p>
                    <div class="user-value"
                     style="cursor: pointer;textDecoration: underline;" @click="ethAddressEvet">
                        TMV2vg...91kE
                    </div>
                </div>
                <div class="user-item">
                    <p class="user-title">
                        <!-- 绑定VDex数量 -->
                        {{$t('miningfee.num')}}
                    </p>
                    <div class="user-value">
                      {{fixDFun(msg.grantAmount,'usdt')}}
                      {{msg.coin}}
                    </div>
                </div>
            </div>
        </div>
        <h3 class="b-1-cl">
            <!-- 手续费存储规则 -->
            {{$t('miningfee.info')}}
        </h3>
        <div class="feeContent b-1-cl" v-html="msg.rule">

        </div>
    </div>
  </div>
</template>
<script>
import imgCard from '@/assets/images/1/feeDetailCard.png';
import {
  fixD,
} from 'BlockChain-ui-privatization/utils';

export default {
  name: 'feeDetail',
  data() {
    return {
      backgroundImg: `url(${imgCard})`,
      feeCoin: 'USDT',
      msg: {},
    };
  },
  mounted() {
    this.getData();
  },
  watch: {

  },
  computed: {
    coinList() {
      if (this.$store.state.baseData.market) {
        return this.$store.state.baseData.market.coinList;
      }
      return null;
    },
  },
  methods: {
    ethAddressEvet() {
      window.open('https://tronscan.org/#/address/TMV2vgTuqai7bqanJEXcqDHVbRSimh91kE');
    },
    showPrecision(symbol) {
      if (this.coinList) {
        // const { coinList } = this.$store.state.baseData.market;
        if (this.coinList[symbol]) {
          const precision = this.coinList[symbol].showPrecision;
          if (precision) {
            return precision;
          }
        }
      }
      return 4;
    },
    fixDFun(val, symbol) {
      if (this.showPrecision(symbol)) {
        return fixD(val, this.showPrecision(symbol));
      }
      return val;
    },
    getData() {
      this.axios({
        url: 'feeInfo',
        hostType: 'miningPool',
        params: {
        },
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          this.msg = data.data;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
  .feeDetail {
    .warp {
        width: 824px;
        margin: 0 auto;
        .common-table {
        background: none;
        }
        .feeCard {
            margin 120px 0 80px 0;
            background: linear-gradient(90deg, #566aff, #3e53f2);
            border-radius: 5px;
            h5 {
                font-size: 20px;
                color: #1F3F59;
                padding-left 60px;
                line-height: 122px;
                color: #FFFFFF;
                opacity: 0.5;
            }
            >p {
                font-size: 12px;
                color: rgba(31,63,89,0.60);
                line-height: 20px;
            }
            .blance {
                box-sizing border-box;
                height: 166px;
                background: linear-gradient(90deg, #3F0E98, #3C35B9);
                padding-left 60px;
                font-weight: bold;
                padding-top 55px;
                color: #FFFFFF;
                font-size 24px;
                b {
                  margin-right 30px;
                }
                span {
                    font-size: 24px;
                    margin-right 28px;
                }
                label {
                  font-size 18px;
                  display: inline-block;
                  vertical-align: middle;
                }
            }
            .user-content {
                display flex;
                box-sizing border-box;
                justify-content space-between;
                padding 34px 65px 52px 65px;
                .user-item {
                  font-weight: bold;
                  color: #FFFFFF;
                    p {
                        font-size: 20px;
                        opacity: 0.5;
                        margin-bottom 16px;
                    }
                    .user-value {
                        font-size: 21px;
                    }
                }
            }
        }
        >b {
            opacity: 0.5;
            border-bottom-width 1px;
            border-bottom-style solid;
            display: block
        }
        >h3 {
            font-size 20px;
            margin-bottom 30px;
        }
        .feeContent {
          font-size:14px;
          line-height 24px;
          p {
            padding-bottom:10px;
          }
        }
    }
  }

</style>
